import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';

import ROUTES from 'routes';
import { useAppDispatch, useAppSelector } from 'hooks';
import { selectAccount } from 'redux/account/selectors';
import { getUserCounters } from 'redux/counters/actions';
import Icon from 'components/Icon';

import MessagesButton from './MessagesButton';
import NavigationLinks from './NavigationLinks';
import AlertsMenuPopover from './AlertsMenuPopover';
import AccountMenu from './AccountMenu';

import css from './Header.module.scss';

interface Props {
    authorized: boolean;
}

const Header: React.FC<Props> = ({ authorized }) => {
    const dispatch = useAppDispatch();

    const account = useAppSelector(selectAccount);

    useEffect(() => {
        if (account) {
            dispatch(getUserCounters());
        }
    }, []);

    if (!account) {
        return (
            <div className={css.header}>
                <div className={css.headerContainer}>
                    <Link to={ROUTES.HOME}>
                        <Icon name="interpals-logo" color="white" width={148} height={26} />
                    </Link>
                </div>
            </div>
        );
    }

    return (
        <div className={css.header}>
            <div className={clsx(css.headerContainer)}>
                <Link to={ROUTES.HOME}>
                    <Icon name="interpals-logo" color="white" width={148} height={26} />
                </Link>
                <div className={css.headerLinks}>
                    {authorized && (
                        <>
                            <NavigationLinks />
                            <MessagesButton />
                            <AlertsMenuPopover />
                            {account && <AccountMenu account={account} />}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default React.memo(Header);
